import React, { Component } from "react";
import { connect } from "react-redux";
import Moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./shipmentSearchBox.css";
import Autosuggest from "react-autosuggest";
import moment from "moment";
import { compareString } from "../../util/utility.js";
import { userConstants } from "../../constants";

// When suggestion is clicked, Autosuggest needs to populate the input
// based on the clicked suggestion. Teach Autosuggest how to calculate the
// input value for every given suggestion.
const getSuggestionValue = (suggestion) => suggestion.shipmentId;

// Use your imagination to render suggestions.
const renderSuggestion = (suggestion) => (
  <div>
    <span>{suggestion.shipmentId}</span>
  </div>
);
class ShipmentSearchBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      flag: false,
      value: "",
      suggestions: [],
      shipmentId: "",
    };
  }
  // componentDidMount() {
  //     this.setState({shipmentId:this.state.value});
  //     console.log('shipmentId:',this.shipmentId);
  // }
  // Auto Suggest functions

  onChange = (event, { newValue }) => {
    // console.log('event:',event)
    // console.log('newValue:',newValue)

    // this.setState({
    //   value: newValue,
    // });

    // console.log();
    this.props.autoOnChange(newValue);
    //  this.setState({shipmentId:newValue});
    // //   this.props.dispatch(getUserContact(newValue));
  };
  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onSuggestionsFetchRequested = ({ value }) => {
    console.log("suggestionvalue:", value);
    //console.log('suggestions:',suggestions);
    this.setState({
      suggestions: this.getSuggestions(value),
    });
    console.log("suggestion:", this.state.suggestions);
  };
  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    });
  };
  getSuggestions = (value) => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;
    // return inputLength === 0 ? [] : this.state.SupplierCode.filter(lang =>
    //   lang.name.toLowerCase().slice(0, inputLength) === inputValue
    // );
    return inputLength === 0
      ? []
      : this.props.shipmentCode.filter(
          (lang) =>
            lang.shipmentId.toLowerCase().slice(0, inputLength) === inputValue
        );
  };
  render() {
    const { showLoader } = this.props;
    console.log("before shipment:", this.state);
    const { value, suggestions } = this.state;

    // Autosuggest will pass through all these props to the input.
    const inputProps = {
      placeholder: "auto search",
      className: "form-control",
      name: "shipmentId",
      value: this.props.data.shipmentId,
      onChange: this.onChange,
    };
    console.log("value---- state", this.state);
    console.log("Data Props:", this.props);
    console.log("Document search:", this.props.document);
    var dateMax = moment(new Date()).format("YYYY-MM-DD");
    console.log("Date:", dateMax);
    return (
      <form onSubmit={this.props.onSearchShipmentHandler} autoComplete="off">
        <div
          className="row contentData"
          style={{ margin: "0.5%", border: "1px solid" }}
        >
          {compareString(this.props.role, userConstants.EDOC_TME_ADMIN) ||
          compareString(this.props.role, "EDOC TME AF USER") ||
          compareString(this.props.role, userConstants.EDOC_TRD_USER) ? (
            <div
              className="col-md-12 col-sm-12 col-xs-12 form-horizontal"
              style={{ marginTop: "1%" }}
            >
              <div className="form-group row">
                <div className="row col-md-6">
                  <label className="col-md-4 col-sm-4 col-xs-4 col-form-label">
                    <b>Shipment ID</b>
                  </label>
                  {/* <div className="form-control"> */}
                  <Autosuggest
                    suggestions={suggestions}
                    onSuggestionsFetchRequested={
                      this.onSuggestionsFetchRequested
                    }
                    onSuggestionsClearRequested={
                      this.onSuggestionsClearRequested
                    }
                    onSuggestionSelected={this.onSuggestionSelected}
                    getSuggestionValue={getSuggestionValue}
                    renderSuggestion={renderSuggestion}
                    inputProps={inputProps}
                    value={this.state.value}
                  />
                </div>
                <div className="row col-md-6">
                  <label className="col-md-4 col-sm-4 col-xs-4 col-form-label">
                    <b>Distributor</b>
                  </label>
                  <div className="col-md-5 col-sm-5 col-xs-5">
                    <select
                      className="form-control"
                      name="distributors"
                      value={this.props.data.distributors}
                      onChange={this.props.onChangeHandler}
                    >
                      {this.props.distributors.map((ele, key) => {
                        return (
                          <option key={key} value={ele.id}>
                            {ele.distNameCode}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
              </div>
              <div className="form-group row">
                <div className="row col-md-6">
                  <label className="col-md-4 col-sm-4 col-xs-4 col-form-label">
                    <b>Depot</b>
                  </label>
                  <div className="col-md-5 col-sm-5 col-xs-5">
                    {/* <select className="form-control" >
                                       <option value="Depot1">Depot1</option>
                                       <option value="Depot2">Depot2</option>
                                        })}
                                    </select> */}
                    <select
                      className="form-control"
                      name="depot"
                      value={this.props.data.depot}
                      onChange={this.props.onChangeHandler}
                    >
                      {this.props.depot.map((ele, key) => {
                        return (
                          <option key={key} value={ele.id}>
                            {ele.code}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
                <div className="row col-md-6">
                  <label className="col-md-4 col-sm-4 col-xs-4 col-form-label">
                    <b>Forwarder</b>
                  </label>
                  <div className="col-md-5 col-sm-5 col-xs-5">
                    <select
                      className="form-control"
                      name="forwarder"
                      value={this.props.data.forwarder}
                      onChange={this.props.onChangeHandler}
                    >
                      {this.props.forwarder.map((ele, key) => {
                        return <option value={ele.id}>{ele.code}</option>;
                      })}
                    </select>
                  </div>
                </div>
              </div>
              <div className="form-group row">
                <div className="row col-md-6">
                  <label className="col-md-4 col-sm-4 col-xs-4 col-form-label">
                    <b>Shipment Date From</b>
                  </label>
                  <div className="col-md-8 col-sm-8 col-xs-8">
                    <DatePicker
                      placeholderText="From Date"
                      dateFormat="YYYY-MM-DD"
                      id="fromDate"
                      name="fromDate"
                      className="form-control"
                      selected={
                        this.props.data.fromDate
                          ? Moment(this.props.data.fromDate, "YYYY-MM-DD")
                          : null
                      }
                      maxDate={Moment(new Date())}
                      showDisabledMonthNavigation
                      onChange={(d) =>
                        this.props.fromDateChangeHandler(d, "fromDate")
                      }
                    />
                    <p className="text-danger alert-control">
                      {this.props.data.fromDateErr}
                    </p>
                  </div>
                </div>
                <div className="row col-md-6">
                  <label className="col-md-4 col-sm-4 col-xs-4 col-form-label">
                    <b>Shipment Date To</b>
                  </label>
                  <div className="col-md-5 col-sm-5 col-xs-5">
                    <DatePicker
                      placeholderText="To Date"
                      dateFormat="YYYY-MM-DD"
                      id="toDate"
                      name="toDate"
                      className="form-control"
                      selected={
                        this.props.data.toDate
                          ? Moment(this.props.data.toDate, "YYYY-MM-DD")
                          : null
                      }
                      minDate={this.props.data.fromDate}
                      maxDate={Moment(new Date())}
                      showDisabledMonthNavigation
                      disabledKeyboardNavigation
                      onChange={(d) =>
                        this.props.toDateChangeHandler(d, "toDate")
                      }
                    />
                    <p className="text-danger alert-control">
                      {this.props.data.toDateErr}
                    </p>
                  </div>
                </div>
              </div>
              <div className="form-group row">
                <div className="row col-md-6">
                  <label className="col-md-4 col-sm-4 col-xs-4 col-form-label">
                    <b> Document Type</b>
                  </label>
                  <div className="col-md-8 col-sm-8 col-xs-8 ">
                    <select
                      className="form-control"
                      name="document"
                      value={this.props.data.document}
                      onChange={this.props.onChangeHandler}
                    >
                      {this.props.document.map((ele, key) => {
                        return <option value={ele.id}>{ele.docType}</option>;
                      })}
                    </select>
                  </div>
                </div>
                <div className="row col-md-6">
                  <label className="col-md-4 col-sm-4 col-xs-4 col-form-label">
                    <b> Transportation Type</b>
                  </label>
                  <div className="col-md-8 col-sm-8 col-xs-8 ">
                    <select
                      className="form-control"
                      name="transportion"
                      value={this.props.data.transportion}
                      onChange={this.props.onChangeHandler}
                    >
                      {this.props.transportion.map((ele, key) => {
                        return <option value={ele.id}>{ele.transType}</option>;
                      })}
                    </select>
                  </div>
                </div>
              </div>
              <div
                className="form-group row pull-right"
                style={{ marginLeft: "0.5%" }}
              >
                {/* <div className="col-md-3 col-sm-3 col-xs-3"> */}
                <button
                  className="btn btn-primary"
                  type="submit"
                  disabled={showLoader}
                >
                  <i
                    className="fa fa-spinner fa-spin"
                    style={{
                      display: showLoader ? "inline-block" : "none",
                      marginLeft: "1px",
                    }}
                  ></i>
                  <i
                    className="fa fa-search"
                    aria-hidden="true"
                    style={{
                      display: !showLoader ? "inline-block" : "none",
                      marginLeft: "1px",
                    }}
                  ></i>
                  Search
                </button>{" "}
                &nbsp;&nbsp;&nbsp;
                {/* </div> */}
                {/* <div className="col-md-3 col-sm-3 col-xs-3"> */}
                <input
                  type="button"
                  className="btn btn-primary"
                  value="Clear"
                  onClick={this.props.onResetHandler}
                />
                {/* </div> */}
              </div>
            </div>
          ) : compareString(
              this.props.role,
              userConstants.EDOC_NMSC_TRD_USER
            ) ? (
            <div
              className="col-md-12 col-sm-12 col-xs-12 form-horizontal"
              style={{ marginTop: "1%" }}
            >
              <div className="form-group row">
                <div className="row col-md-6">
                  <label className="col-md-4 col-sm-4 col-xs-4 col-form-label">
                    <b>Shipment ID</b>
                  </label>
                  {/* <div className="form-control"> */}
                  <Autosuggest
                    suggestions={suggestions}
                    onSuggestionsFetchRequested={
                      this.onSuggestionsFetchRequested
                    }
                    onSuggestionsClearRequested={
                      this.onSuggestionsClearRequested
                    }
                    onSuggestionSelected={this.onSuggestionSelected}
                    getSuggestionValue={getSuggestionValue}
                    renderSuggestion={renderSuggestion}
                    inputProps={inputProps}
                    value={this.state.value}
                  />
                </div>
                <div className="row col-md-6">
                  <label className="col-md-4 col-sm-4 col-xs-4 col-form-label">
                    <b> Document Type</b>
                  </label>
                  <div className="col-md-8 col-sm-8 col-xs-8 ">
                    <select
                      className="form-control"
                      name="document"
                      value={this.props.data.document}
                      onChange={this.props.onChangeHandler}
                    >
                      {this.props.document.map((ele, key) => {
                        return <option value={ele.id}>{ele.docType}</option>;
                      })}
                    </select>
                  </div>
                </div>
              </div>
              <div className="form-group row">
                <div className="row col-md-6">
                  <label className="col-md-4 col-sm-4 col-xs-4 col-form-label">
                    <b>Distributor</b>
                  </label>
                  <div className="col-md-5 col-sm-5 col-xs-5">
                    <select
                      className="form-control"
                      name="distributors"
                      value={this.props.data.distributors}
                      onChange={this.props.onChangeHandler}
                    >
                      {this.props.distributors.map((ele, key) => {
                        return (
                          <option key={key} value={ele.id}>
                            {ele.distNameCode}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
                <div className="row col-md-6">
                  <label className="col-md-4 col-sm-4 col-xs-4 col-form-label">
                    <b>Forwarder</b>
                  </label>
                  <div className="col-md-5 col-sm-5 col-xs-5">
                    <select
                      className="form-control"
                      name="forwarder"
                      value={this.props.data.forwarder}
                      onChange={this.props.onChangeHandler}
                    >
                      {this.props.forwarder.map((ele, key) => {
                        return <option value={ele.id}>{ele.code}</option>;
                      })}
                    </select>
                  </div>
                </div>
              </div>
              <div className="form-group row">
                <div className="row col-md-6">
                  <label className="col-md-4 col-sm-4 col-xs-4 col-form-label">
                    <b>Shipment Date From</b>
                  </label>
                  <div className="col-md-8 col-sm-8 col-xs-8">
                    <DatePicker
                      placeholderText="From Date"
                      dateFormat="YYYY-MM-DD"
                      id="fromDate"
                      name="fromDate"
                      className="form-control"
                      selected={
                        this.props.data.fromDate
                          ? Moment(this.props.data.fromDate, "YYYY-MM-DD")
                          : null
                      }
                      maxDate={Moment(new Date())}
                      showDisabledMonthNavigation
                      onChange={(d) =>
                        this.props.fromDateChangeHandler(d, "fromDate")
                      }
                    />
                    <p className="text-danger alert-control">
                      {this.props.data.fromDateErr}
                    </p>
                  </div>
                </div>
                <div className="row col-md-6">
                  <label className="col-md-4 col-sm-4 col-xs-4 col-form-label">
                    <b>Shipment Date To</b>
                  </label>
                  <div className="col-md-5 col-sm-5 col-xs-5">
                    <DatePicker
                      placeholderText="To Date"
                      dateFormat="YYYY-MM-DD"
                      id="toDate"
                      name="toDate"
                      className="form-control"
                      selected={
                        this.props.data.toDate
                          ? Moment(this.props.data.toDate, "YYYY-MM-DD")
                          : null
                      }
                      minDate={this.props.data.fromDate}
                      maxDate={Moment(new Date())}
                      showDisabledMonthNavigation
                      disabledKeyboardNavigation
                      onChange={(d) =>
                        this.props.toDateChangeHandler(d, "toDate")
                      }
                    />
                    <p className="text-danger alert-control">
                      {this.props.data.toDateErr}
                    </p>
                  </div>
                </div>
              </div>
              <div className="row col-md-6">
                <label className="col-md-4 col-sm-4 col-xs-4 col-form-label">
                  <b> Transportation Type</b>
                </label>
                <div className="col-md-8 col-sm-8 col-xs-8 ">
                  <select
                    className="form-control"
                    name="transportion"
                    value={this.props.data.transportion}
                    onChange={this.props.onChangeHandler}
                  >
                    {this.props.transportion.map((ele, key) => {
                      return <option value={ele.id}>{ele.transType}</option>;
                    })}
                  </select>
                </div>
              </div>
              <div
                className="form-group row pull-right"
                style={{ marginLeft: "0.5%" }}
              >
                {/* <div className="col-md-3 col-sm-3 col-xs-3"> */}
                <button
                  className="btn btn-primary"
                  type="submit"
                  disabled={showLoader}
                >
                  <i
                    className="fa fa-spinner fa-spin"
                    style={{
                      display: showLoader ? "inline-block" : "none",
                      marginLeft: "1px",
                    }}
                  ></i>
                  <i
                    className="fa fa-search"
                    aria-hidden="true"
                    style={{
                      display: !showLoader ? "inline-block" : "none",
                      marginLeft: "1px",
                    }}
                  ></i>
                  Search
                </button>{" "}
                &nbsp;&nbsp;&nbsp;
                {/* </div> */}
                {/* <div className="col-md-3 col-sm-3 col-xs-3"> */}
                <input
                  type="button"
                  className="btn btn-primary"
                  value="Clear"
                  onClick={this.props.onResetHandler}
                />
                {/* </div> */}
              </div>
            </div>
          ) : compareString(
              this.props.role,
              userConstants.EDOC_FORWARDER_USER
            ) ? (
            <div
              className="col-md-12 col-sm-12 col-xs-12 form-horizontal"
              style={{ marginTop: "1%" }}
            >
              <div className="form-group row">
                <div className="row col-md-6">
                  <label className="col-md-4 col-sm-4 col-xs-4 col-form-label">
                    <b>Shipment ID</b>
                  </label>
                  {/* <div className="form-control"> */}
                  <Autosuggest
                    suggestions={suggestions}
                    onSuggestionsFetchRequested={
                      this.onSuggestionsFetchRequested
                    }
                    onSuggestionsClearRequested={
                      this.onSuggestionsClearRequested
                    }
                    onSuggestionSelected={this.onSuggestionSelected}
                    getSuggestionValue={getSuggestionValue}
                    renderSuggestion={renderSuggestion}
                    inputProps={inputProps}
                    value={this.state.value}
                  />
                </div>
                <div className="row col-md-6">
                  <label className="col-md-4 col-sm-4 col-xs-4 col-form-label">
                    <b> Document Type</b>
                  </label>
                  <div className="col-md-8 col-sm-8 col-xs-8 ">
                    <select
                      className="form-control"
                      name="document"
                      value={this.props.data.document}
                      onChange={this.props.onChangeHandler}
                    >
                      {this.props.document.map((ele, key) => {
                        return <option value={ele.id}>{ele.docType}</option>;
                      })}
                    </select>
                  </div>
                </div>
              </div>

              <div className="form-group row">
                <div className="row col-md-6">
                  <label className="col-md-4 col-sm-4 col-xs-4 col-form-label">
                    <b>Shipment Date From</b>
                  </label>
                  <div className="col-md-8 col-sm-8 col-xs-8">
                    <DatePicker
                      placeholderText="From Date"
                      dateFormat="YYYY-MM-DD"
                      id="fromDate"
                      name="fromDate"
                      className="form-control"
                      selected={
                        this.props.data.fromDate
                          ? Moment(this.props.data.fromDate, "YYYY-MM-DD")
                          : null
                      }
                      maxDate={Moment(new Date())}
                      showDisabledMonthNavigation
                      onChange={(d) =>
                        this.props.fromDateChangeHandler(d, "fromDate")
                      }
                    />
                    <p className="text-danger alert-control">
                      {this.props.data.fromDateErr}
                    </p>
                  </div>
                </div>
                <div className="row col-md-6">
                  <label className="col-md-4 col-sm-4 col-xs-4 col-form-label">
                    <b>Shipment Date To</b>
                  </label>
                  <div className="col-md-5 col-sm-5 col-xs-5">
                    <DatePicker
                      placeholderText="To Date"
                      dateFormat="YYYY-MM-DD"
                      id="toDate"
                      name="toDate"
                      className="form-control"
                      selected={
                        this.props.data.toDate
                          ? Moment(this.props.data.toDate, "YYYY-MM-DD")
                          : null
                      }
                      minDate={this.props.data.fromDate}
                      maxDate={Moment(new Date())}
                      showDisabledMonthNavigation
                      disabledKeyboardNavigation
                      onChange={(d) =>
                        this.props.toDateChangeHandler(d, "toDate")
                      }
                    />
                    <p className="text-danger alert-control">
                      {this.props.data.toDateErr}
                    </p>
                  </div>
                </div>
              </div>
              <div className="row col-md-6">
                <label className="col-md-4 col-sm-4 col-xs-4 col-form-label">
                  <b> Transportation Type</b>
                </label>
                <div className="col-md-8 col-sm-8 col-xs-8 ">
                  <select
                    className="form-control"
                    name="transportion"
                    value={this.props.data.transportion}
                    onChange={this.props.onChangeHandler}
                  >
                    {this.props.transportion.map((ele, key) => {
                      return <option value={ele.id}>{ele.transType}</option>;
                    })}
                  </select>
                </div>
              </div>
              <div
                className="form-group row pull-right"
                style={{ marginLeft: "0.5%" }}
              >
                {/* <div className="col-md-3 col-sm-3 col-xs-3"> */}
                <button
                  className="btn btn-primary"
                  type="submit"
                  disabled={showLoader}
                >
                  <i
                    className="fa fa-spinner fa-spin"
                    style={{
                      display: showLoader ? "inline-block" : "none",
                      marginLeft: "1px",
                    }}
                  ></i>
                  <i
                    className="fa fa-search"
                    aria-hidden="true"
                    style={{
                      display: !showLoader ? "inline-block" : "none",
                      marginLeft: "1px",
                    }}
                  ></i>
                  Search
                </button>{" "}
                &nbsp;&nbsp;&nbsp;
                {/* </div> */}
                {/* <div className="col-md-3 col-sm-3 col-xs-3"> */}
                <input
                  type="button"
                  className="btn btn-primary"
                  value="Clear"
                  onClick={this.props.onResetHandler}
                />
                {/* </div> */}
              </div>
            </div>
          ) : compareString(this.props.role, userConstants.EDOC_DEPOT_USER) ? (
            <div
              className="col-md-12 col-sm-12 col-xs-12 form-horizontal"
              style={{ marginTop: "1%" }}
            >
              <div className="form-group row">
                <div className="row col-md-6">
                  <label className="col-md-4 col-sm-4 col-xs-4 col-form-label">
                    <b>Shipment ID</b>
                  </label>
                  {/* <div className="form-control"> */}
                  <Autosuggest
                    suggestions={suggestions}
                    onSuggestionsFetchRequested={
                      this.onSuggestionsFetchRequested
                    }
                    onSuggestionsClearRequested={
                      this.onSuggestionsClearRequested
                    }
                    onSuggestionSelected={this.onSuggestionSelected}
                    getSuggestionValue={getSuggestionValue}
                    renderSuggestion={renderSuggestion}
                    inputProps={inputProps}
                    value={this.state.value}
                  />
                </div>
                <div className="row col-md-6">
                  <label className="col-md-4 col-sm-4 col-xs-4 col-form-label">
                    <b>Forwarder</b>
                  </label>
                  <div className="col-md-5 col-sm-5 col-xs-5">
                    <select
                      className="form-control"
                      name="forwarder"
                      value={this.props.data.forwarder}
                      onChange={this.props.onChangeHandler}
                    >
                      {this.props.forwarder.map((ele, key) => {
                        return <option value={ele.id}>{ele.code}</option>;
                      })}
                    </select>
                  </div>
                </div>
              </div>

              <div className="form-group row">
                <div className="row col-md-6">
                  <label className="col-md-4 col-sm-4 col-xs-4 col-form-label">
                    <b>Shipment Date From</b>
                  </label>
                  <div className="col-md-8 col-sm-8 col-xs-8">
                    <DatePicker
                      placeholderText="From Date"
                      dateFormat="YYYY-MM-DD"
                      id="fromDate"
                      name="fromDate"
                      className="form-control"
                      selected={
                        this.props.data.fromDate
                          ? Moment(this.props.data.fromDate, "YYYY-MM-DD")
                          : null
                      }
                      maxDate={Moment(new Date())}
                      showDisabledMonthNavigation
                      onChange={(d) =>
                        this.props.fromDateChangeHandler(d, "fromDate")
                      }
                    />
                    <p className="text-danger alert-control">
                      {this.props.data.fromDateErr}
                    </p>
                  </div>
                </div>
                <div className="row col-md-6">
                  <label className="col-md-4 col-sm-4 col-xs-4 col-form-label">
                    <b>Shipment Date To</b>
                  </label>
                  <div className="col-md-5 col-sm-5 col-xs-5">
                    <DatePicker
                      placeholderText="To Date"
                      dateFormat="YYYY-MM-DD"
                      id="toDate"
                      name="toDate"
                      className="form-control"
                      selected={
                        this.props.data.toDate
                          ? Moment(this.props.data.toDate, "YYYY-MM-DD")
                          : null
                      }
                      minDate={this.props.data.fromDate}
                      maxDate={Moment(new Date())}
                      showDisabledMonthNavigation
                      disabledKeyboardNavigation
                      onChange={(d) =>
                        this.props.toDateChangeHandler(d, "toDate")
                      }
                    />
                    <p className="text-danger alert-control">
                      {this.props.data.toDateErr}
                    </p>
                  </div>
                </div>
              </div>
              <div className="form-group row">
                <div className="row col-md-6">
                  <label className="col-md-4 col-sm-4 col-xs-4 col-form-label">
                    <b> Transportation Type</b>
                  </label>
                  <div className="col-md-8 col-sm-8 col-xs-8 ">
                    <select
                      className="form-control"
                      name="transportion"
                      value={this.props.data.transportion}
                      onChange={this.props.onChangeHandler}
                    >
                      {this.props.transportion.map((ele, key) => {
                        return <option value={ele.id}>{ele.transType}</option>;
                      })}
                    </select>
                  </div>
                </div>
                <div className="row col-md-6">
                  <label className="col-md-4 col-sm-4 col-xs-4 col-form-label">
                    <b> Document Type</b>
                  </label>
                  <div className="col-md-8 col-sm-8 col-xs-8 ">
                    <select
                      className="form-control"
                      name="document"
                      value={this.props.data.document}
                      onChange={this.props.onChangeHandler}
                    >
                      {this.props.document.map((ele, key) => {
                        return <option value={ele.id}>{ele.docType}</option>;
                      })}
                    </select>
                  </div>
                </div>
              </div>
              <div
                className="form-group row pull-right"
                style={{ marginLeft: "0.5%" }}
              >
                {/* <div className="col-md-3 col-sm-3 col-xs-3"> */}
                <button
                  className="btn btn-primary"
                  type="submit"
                  disabled={showLoader}
                >
                  <i
                    className="fa fa-spinner fa-spin"
                    style={{
                      display: showLoader ? "inline-block" : "none",
                      marginLeft: "1px",
                    }}
                  ></i>
                  <i
                    className="fa fa-search"
                    aria-hidden="true"
                    style={{
                      display: !showLoader ? "inline-block" : "none",
                      marginLeft: "1px",
                    }}
                  ></i>
                  Search
                </button>{" "}
                &nbsp;&nbsp;&nbsp;
                {/* </div> */}
                {/* <div className="col-md-3 col-sm-3 col-xs-3"> */}
                <input
                  type="button"
                  className="btn btn-primary"
                  value="Clear"
                  onClick={this.props.onResetHandler}
                />
                {/* </div> */}
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </form>
    );
  }
}

function mapStateToProps(state) {
  console.log("stateShow:", state);
  const showLoader = state.spinner.show;
  return {
    showLoader,
    alert,
  };
}

const connectedLoginPage = connect(mapStateToProps)(ShipmentSearchBox);
export { connectedLoginPage as ShipmentSearchBox };
